<script setup lang="ts">
const ServicesCMSContent = defineAsyncComponent(() => import('~/components/molecules/ServicesCMSContent.vue'));

definePageMeta({
  layout: "services-layout",
});
</script>

<template>
    <ServicesCMSContent />
</template>